
import { Injectable } from '@angular/core'
import { Action } from '@ngrx/store'
import { User, UserAccess } from './user.model'

/**
 * User Add action
 */
export const ADD_USER = '[USER] Add'
/**
 * User remove action
 */
export const REMOVE_USER = '[USER] Remove'
/**
 * User update action
 */
export const UPDATE_USER = '[USER] Update'

/**
 * Action to add a user.
 */
export class AddUser implements Action {
  readonly type = ADD_USER
  constructor(public payload: User) { }
}

/**
 * Action to remove a user.
 */
export class RemoveUser implements Action {
  readonly type = REMOVE_USER

  constructor(public payload: number) { }
}

/**
 * Action to update a user.
 */
export class UpdateUser implements Action {
  readonly type = UPDATE_USER

  constructor(public payload: number) { }
}

/**
 * Export action types
 */
export type Actions = AddUser | RemoveUser | UpdateUser
